"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSubmitError = exports.sendSubmitInvalidEvent = exports.sendFieldInvalidEvent = void 0;
const services_1 = require("../../../services/index.js");
const types_1 = require("../../../types/index.js");
const sendFieldInvalidEvent = (target, fieldName, reason) => (0, services_1.sendEvent)((0, services_1.getCategory)(window.location.host, target), types_1.TRACKING_ACTIONS.validation, `${fieldName}:erro:${reason}`);
exports.sendFieldInvalidEvent = sendFieldInvalidEvent;
const sendSubmitInvalidEvent = (target) => (0, services_1.sendEvent)((0, services_1.getCategory)(window.location.host, target), types_1.TRACKING_ACTIONS.signup, 'erro:validacao-formulario');
exports.sendSubmitInvalidEvent = sendSubmitInvalidEvent;
/**
 * Função para processar possíveis erros de validação dos campos do formulário.
 */
const handleSubmitError = (errors, e) => {
    var _a;
    (0, exports.sendSubmitInvalidEvent)(e === null || e === void 0 ? void 0 : e.target);
    for (const fieldName in errors) {
        const reason = (_a = errors[fieldName]) === null || _a === void 0 ? void 0 : _a.type;
        (0, exports.sendFieldInvalidEvent)(e === null || e === void 0 ? void 0 : e.target, fieldName, reason);
    }
};
exports.handleSubmitError = handleSubmitError;
